"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useCallback, useEffect, useState } from 'react';
import socketIOClient from 'socket.io-client';
import { useFlixApiContext } from './FlixApiContext';
import { useAuthStatus } from './user/AuthStatus/useAuthStatusQuery';
/**
 * Opens a connection with the websocket server provided all conditions are met. Make sure you
 * pass in a memoized query, or the socket will reconnect every render.
 */

export var useSocketIoClient = function useSocketIoClient(_ref) {
  var memoizedQuery = _ref.memoizedQuery,
      connectionEnabled = _ref.connectionEnabled;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      socket = _useState2[0],
      setSocket = _useState2[1];

  var _useFlixApiContext = useFlixApiContext(),
      authTokenStore = _useFlixApiContext.authTokenStore,
      webSocketDomain = _useFlixApiContext.webSocketDomain,
      webSocketUnsecured = _useFlixApiContext.webSocketUnsecured,
      webSocketPollingDisabled = _useFlixApiContext.webSocketPollingDisabled;

  var webSocketRoot = "".concat(webSocketUnsecured ? 'ws' : 'wss', "://").concat(webSocketDomain);
  var flixAuth = authTokenStore.get();

  var _useAuthStatus = useAuthStatus(),
      memberId = _useAuthStatus.id;

  useEffect(function () {
    if (connectionEnabled && memberId) {
      // this only runs when relevant parameters change, so if there is an existing
      // socket then it needs to be updated
      if (socket) socket.disconnect();
      var newSocket = socketIOClient(webSocketRoot, {
        path: '/socket.io',
        query: _objectSpread(_objectSpread({
          memberId: memberId
        }, memoizedQuery), webSocketPollingDisabled ? {
          flixAuth: flixAuth
        } : {}),
        // without this, localhost will throw a CORS error when developing
        transports: webSocketPollingDisabled ? ['websocket'] : undefined,
        reconnectionAttempts: 10,
        transportOptions: {
          polling: {
            extraHeaders: {
              flixAuth: flixAuth
            }
          }
        }
      });
      setSocket(newSocket);
      return function () {
        return newSocket.disconnect();
      };
    } // we need to exclude `socket` from the dependencies array or this won't work
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [flixAuth, memoizedQuery, connectionEnabled, memberId, webSocketRoot]);
  var socketConnected = useCallback(function () {
    return socket === null || socket === void 0 ? void 0 : socket.connected;
  }, [socket]);
  return {
    socket: socket,
    socketConnected: socketConnected
  };
};